import React, { PropTypes } from 'react';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { isUndefinedNullOrEmpty } from '../../../js/utils';
import { reliablyHandleFormSubmit } from '../../common/formUtils';
import { setCloneDestination } from '../../../js/actions/cloningWorkflowActionCreators';
import selectionElementMode from '../../common/selectionElementMode';
import SqlServerInstanceSelection from '../../common/SqlServerInstanceSelection';
import InlineValidationMessage from '../../common/InlineValidationMessage';
import FormErrorNotification from '../../common/FormErrorNotification';
import BackLink from '../../common/BackLink';

const validate = (values) => {
    const errors = {};

    if (isUndefinedNullOrEmpty(values.destinationId)) {
        errors.destinationId = 'Select a SQL Server instance';
    }

    return errors;
};

const renderServerSelectionField = (props) => {
    return <div>
        <SqlServerInstanceSelection labelText="SQL Server Instance" value={props.input.value} autoFocus={props.autoFocus} onChange={props.input.onChange} onModeChanged={props.onModeChanged} />
        <InlineValidationMessage touched={props.meta.touched} error={props.meta.error} />
    </div>;
};

renderServerSelectionField.propTypes = {
    input: PropTypes.object.isRequired,
    meta: PropTypes.object.isRequired,
    onModeChanged: PropTypes.func.isRequired
};

const CloneDestinationForm = React.createClass({
    propTypes: {
        serverInstances: PropTypes.object.isRequired,
        selectedDestination: PropTypes.string,
        handleSubmit: PropTypes.func.isRequired,
        pristine: PropTypes.bool.isRequired,
        submitting: PropTypes.bool.isRequired,
        onFormValid: PropTypes.func.isRequired,
        error: PropTypes.string,
        valid: PropTypes.bool.isRequired
    },
    getInitialState: function () {
        return {
            isOnSqlServerInstanceAddMode: false
        };
    },
    onSqlServerSelectionModeChanged: function (mode) {
        this.setState({ isOnSqlServerInstanceAddMode: mode === selectionElementMode.add });
    },
    render: function () {
        const { handleSubmit, pristine, submitting, valid, onFormValid, error, selectedDestination } = this.props;
        const { isOnSqlServerInstanceAddMode } = this.state;
        const isDestinationSelected = !isUndefinedNullOrEmpty(selectedDestination);

        const goToNext = (data) => {
            return reliablyHandleFormSubmit(() => {
                const destination = {
                    id: data.destinationId
                };

                onFormValid(destination);
                browserHistory.push('/clones/create/review');
            });
        };

        return <form onSubmit={handleSubmit(goToNext)}>
            <div className="form-container">
                <div className="form-content">
                    <BackLink />
                    {!isOnSqlServerInstanceAddMode && <h1>Clone destination</h1>}

                    <FormErrorNotification error={error} />

                    <div className="control-holder">
                        <Field name="destinationId" placeholder="Select a server instance" labelText="SQL Server instance" autoFocus
                            onModeChanged={this.onSqlServerSelectionModeChanged} component={renderServerSelectionField} />
                    </div>

                    {(!isOnSqlServerInstanceAddMode && valid && !pristine) &&
                        <button type="submit" className="button button--primary" disabled={submitting}>
                            Next
                        </button>}
                </div>
            </div>
        </form>;
    }
});

const formName = 'CloneDestination';
const selector = formValueSelector(formName);

const mapStateToProps = (state) => ({
    serverInstances: state.sqlServerInstances,
    selectedDestination: selector(state, 'destinationId')
});

const mapDispatchToProps = (dispatch) => ({
    onFormValid: (destination) => {
        dispatch(setCloneDestination(destination));
    }
});

export default reduxForm({ form: formName, validate })(
    connect(mapStateToProps, mapDispatchToProps)(CloneDestinationForm)
);


// WEBPACK FOOTER //
// ./src/components/cloning/CloneDestinationPage/cloneDestinationForm.jsx